export default __webpack_public_path__ + "static/media/section2_3.ed7e044e.svg";